
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
	import Dialog from '@/components/dialog.vue';
	import Message from '@/components/message.vue';
	import UploadImg from '@/components/upload-img.vue';
  import {
    getSearchDate,
    nextDay
  } from "@/utils"
  import {
    productConsumeStatislist,
    productConsumeStatisedit,
    productConsumeStatisdelete,
    productConsumeStatisimport,
  } from "@/api/order"
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate,
			'slz-dialog': Dialog,
			'slz-message': Message,
      UploadImg
    }
  })

  export default class ProductList extends Vue {
    private keywords = ''
    private filterTime = ''
    private tablelist:any = []
    private tableloading = false
    private pageNo = 1;
		private pageSize = 10;
		private total = 0;
    private tipShow = false
    private rowmsg:any = {}
    private editShow = false
    private editloading = false
    private importShow = false
    private importloading = false
    private filepath = ''
    private filename = ''
    private fileList = []
    private schedule = 0
    private result:any = {}

    private mounted () {
      this.initTime()
      this.gettablelist()
    }


    private blurCount(e){
      this.rowmsg.ProductCount = e.target.value
    }
    private exportfile(){
      let url = location.origin + '/pc/productConsumeStatis/list'
      url += '?ProductInfo=' + encodeURIComponent(this.keywords)
      if(this.filterTime){
        let t = this.filterTime.split('/')
        url += '&StartTime=' + t[0]
        url += '&EndTime=' + nextDay(t[1],1)
      }
      window.open(url)
    }
    private exportResult(){
      let url = location.origin + '/pc/productConsumeStatis/downloadDealResult?ImportRecordId='+this.result.ImportRecordId
      window.open(url)
    }
    private async toupload(){
      if(!this.filepath){
        this.$message.error('请选择文件上传')
        return
      }
      this.schedule = 0
      this.importloading = true
      try{
        let res:any = await productConsumeStatisimport({
          ExcelFilePath:this.filepath,
          ExcelFileName:this.filename
        })
        if(res.IsSuccess){
          this.result = res.Result
          if(res.Result.ImportState==1){//成功
            this.schedule = 2
            this.$message.success('操作成功')
            this.gettablelist()
          }else{//失败
            this.schedule = 1
          }
        }
      }finally{
        this.importloading = false
      }
    }
    private uploadSuc(file,name){
      this.filepath = file[0]
      this.filename = name
    }
    private async confirmsave(){
      if(!this.rowmsg.ProductCount||this.rowmsg.ProductCount<1||this.rowmsg.ProductCount>10000){
        this.$message.error('请输入1万以内的正确数量')
        return
      }
      try{
        this.editloading = true
        let res:any = await productConsumeStatisedit({
          ...this.rowmsg
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.gettablelist()
          this.editShow = false
        }
      }finally{
        this.editloading = false
      }
    }
    private toEdit(row){
      this.rowmsg = JSON.parse(JSON.stringify(row))
      this.editShow = true
    }
    private async confirmdel(){
      try{
        this.tableloading = true
        let res:any = await productConsumeStatisdelete({
          ProductConsumeStatisImportDetailId:this.rowmsg.ProductConsumeStatisImportDetailId
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.gettablelist()
        }
      }finally{
        this.tableloading = false
      }
    }
    private todel(row){
      this.rowmsg = row
      this.tipShow = true
    }
    private importfile(){
      this.schedule = 0
      this.fileList = []
      this.filename = ''
      this.filepath = ''
      this.importShow = true
    }
    private initTime(){
      let year = new Date().getFullYear()
      this.filterTime = year + '-01-01/' + getSearchDate(2)[0]
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any = {
          ProductInfo:this.keywords,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        }
        if(this.filterTime){
          let t = this.filterTime.split('/')
          data.StartTime = t[0]
          data.EndTime = nextDay(t[1],1)
        }
        let res:any = await productConsumeStatislist(data)
        if(res.IsSuccess){
          this.total = res.Result.Total
          this.tablelist = res.Result.Results
        }
      }finally{
        this.tableloading = false
      }
    }
    private clearSearch(){
      this.keywords = ''
      this.initTime()
      this.query()
    }
    private query(){
      this.pageNo = 1
      this.gettablelist()
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
  }
